import { render } from "./AppCollapsable.vue?vue&type=template&id=41121e94&scoped=true"
import script from "./AppCollapsable.vue?vue&type=script&lang=js"
export * from "./AppCollapsable.vue?vue&type=script&lang=js"

import "./AppCollapsable.vue?vue&type=style&index=0&id=41121e94&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41121e94"]])

export default __exports__